import React from 'react';
import { Segment, Icon, SemanticICONS } from 'semantic-ui-react';
import './StatCard.css';

interface StatCardProps {
  icon: SemanticICONS;
  iconColor: 'green' | 'blue' | 'purple' | 'orange';
  value: string;
  label: string;
  trend?: {
    value: string;
    positive: boolean;
  };
}

const StatCard: React.FC<StatCardProps> = ({ icon, iconColor, value, label, trend }) => (
  <Segment className="stat-card">
    <div className="stat-header">
      <div className={`stat-icon ${iconColor}`}>
        <Icon name={icon} />
      </div>
      {trend && (
        <span className={`stat-trend ${trend.positive ? 'up' : 'down'}`}>
          <Icon name={trend.positive ? 'arrow up' : 'arrow down'} size="small" />
          {trend.value}
        </span>
      )}
    </div>
    <div className="stat-value">{value}</div>
    <div className="stat-label">{label}</div>
  </Segment>
);

export default StatCard;




